import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight, FileEdit } from "lucide-react";
const GOVT_HOLIDAYS_2026 = [{
  name: "New Year's Day",
  date: "01 Jan"
}, {
  name: "Pongal",
  date: "14 Jan"
}, {
  name: "Thiruvalluvar Day",
  date: "15 Jan"
}, {
  name: "Uzhavar Thirunal",
  date: "16 Jan"
}, {
  name: "Republic Day",
  date: "26 Jan"
}, {
  name: "Maha Shivaratri",
  date: "25 Feb"
}, {
  name: "Id ul Fitr",
  date: "31 Mar"
}, {
  name: "Tamil New Year",
  date: "14 Apr"
}, {
  name: "Good Friday",
  date: "03 Apr"
}, {
  name: "Dr. Ambedkar Jayanti",
  date: "14 Apr"
}, {
  name: "May Day",
  date: "01 May"
}, {
  name: "Id ul Adha",
  date: "07 Jun"
}, {
  name: "Independence Day",
  date: "15 Aug"
}, {
  name: "Gandhi Jayanti",
  date: "02 Oct"
}, {
  name: "Ayutha Pooja",
  date: "22 Oct"
}, {
  name: "Vijayadasami",
  date: "23 Oct"
}, {
  name: "Diwali",
  date: "20 Oct"
}, {
  name: "Christmas",
  date: "25 Dec"
}];
const DEPT_COLORS = {
  Maths: "#0D47A1",
  Science: "#1976D2",
  Tamil: "#006994",
  English: "#0288D1",
  Social: "#1976D2",
  Admin: "#0D47A1",
  "Bio Maths": "#0D47A1",
  "Computer Science": "#1976D2",
  "Art & Science": "#006994",
  Commerce: "#0288D1"
};
const AV_COLORS = {
  Maths: {
    bg: "#E3F2FD",
    color: "#0D47A1"
  },
  Science: {
    bg: "#BBDEFB",
    color: "#1976D2"
  },
  Tamil: {
    bg: "#E3F2FD",
    color: "#006994"
  },
  English: {
    bg: "#BBDEFB",
    color: "#0288D1"
  },
  Social: {
    bg: "#E3F2FD",
    color: "#1976D2"
  },
  Admin: {
    bg: "#BBDEFB",
    color: "#0D47A1"
  },
  "Bio Maths": {
    bg: "#E3F2FD",
    color: "#0D47A1"
  },
  "Computer Science": {
    bg: "#BBDEFB",
    color: "#1976D2"
  },
  "Art & Science": {
    bg: "#E3F2FD",
    color: "#006994"
  },
  Commerce: {
    bg: "#BBDEFB",
    color: "#0288D1"
  }
};

/* ── Responsive CSS injected once ── */
const RESPONSIVE_CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap');
  @import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0-beta3/css/all.min.css');

  * { margin: 0; padding: 0; box-sizing: border-box; }

  body {
    font-family: 'Poppins', sans-serif;
    background: #E3F2FD; /* Updated to match Parent Dashboard */
    color: #0D2436;
  }

  ::-webkit-scrollbar { width: 5px; height: 5px; }
  ::-webkit-scrollbar-track { background: #BBDEFB; border-radius: 10px; }
  ::-webkit-scrollbar-thumb { background: #0D47A1; border-radius: 10px; }

  .sda-page { min-height: 100vh; background: #E3F2FD; font-family: 'Poppins', sans-serif; }

  /* ── Header ── */
  .sda-header {
    /* Updated to Blue Theme Gradient */
    background: linear-gradient(135deg, #0D47A1, #006994);
    padding: 14px 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    flex-wrap: wrap;
    box-shadow: 0 4px 16px rgba(13, 71, 161, 0.2);
  }
  .sda-header-left { display: flex; align-items: center; gap: 12px; }
  .sda-back-btn {
    background: rgba(255,255,255,0.15); border: none; border-radius: 10px;
    width: 38px; height: 38px; display: flex; align-items: center; justify-content: center;
    cursor: pointer; color: #fff; font-size: 16px; flex-shrink: 0;
    transition: all 0.2s;
  }
  .sda-back-btn:hover { background: rgba(255,255,255,0.3); }
  .sda-header-icon {
    width: 34px; height: 34px; border-radius: 10px; background: rgba(255,255,255,0.2);
    display: flex; align-items: center; justify-content: center; flex-shrink: 0;
  }
  .sda-header-title { font-weight: 700; font-size: 15px; color: #fff; }
  .sda-header-sub   { font-size: 11px; color: #E3F2FD; margin-top: 1px; }

  /* ── Clock ── */
  .sda-clock { text-align: right; }
  .sda-clock-time { font-weight: 700; font-size: 20px; color: #fff; letter-spacing: 1px; font-family: monospace; }
  .sda-clock-date { font-size: 11px; color: #E3F2FD; margin-top: 1px; }

  /* ── Toast ── */
  .sda-toast {
    position: fixed; top: 16px; right: 16px; z-index: 9999;
    padding: 11px 18px; border-radius: 12px; font-size: 13px; font-weight: 500;
    display: flex; align-items: center; gap: 8px;
    box-shadow: 0 4px 20px rgba(0,0,0,0.15);
    max-width: calc(100vw - 32px);
  }

  /* ── Main container ── */
  .sda-container { max-width: 1320px; margin: 0 auto; padding: 20px 16px 40px; }

  /* ── Two-column layout so the page fills the full width, no dead space ── */
  .sda-layout {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1.25fr);
    gap: 20px;
    align-items: start;
  }
  @media (max-width: 900px) {
    .sda-layout { grid-template-columns: 1fr; }
  }
  .sda-col { display: flex; flex-direction: column; min-width: 0; }
  .sda-col .sda-card:last-child { margin-bottom: 0; }

  /* ── History card header with month picker ── */
  .sda-history-header {
    padding: 14px 18px; border-bottom: 1px solid #E3F2FD;
    display: flex; align-items: center; justify-content: space-between;
    gap: 10px; flex-wrap: wrap;
  }
  .sda-month-input {
    border: 1px solid #BBDEFB; border-radius: 8px; padding: 6px 10px;
    font-size: 12px; font-family: 'Poppins', sans-serif; color: #0D47A1;
    background: #E3F2FD; outline: none; cursor: pointer;
  }
  .sda-history-scroll { max-height: 520px; overflow-y: auto; }

  /* ── Pending banner ── */
  .sda-pending-banner {
    background: #FFF3E0; border: 1px solid #FFE0B2; border-radius: 12px;
    padding: 12px 14px; margin-bottom: 18px;
    display: flex; align-items: center; justify-content: space-between;
    flex-wrap: wrap; gap: 10px;
  }
  .sda-pending-left { display: flex; align-items: center; gap: 10px; }

  /* ── Stats grid ── */
  .sda-stats-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 12px;
    margin-bottom: 20px;
  }
  @media (max-width: 520px) {
    .sda-stats-grid { grid-template-columns: repeat(2, 1fr); }
    .sda-stats-grid > :last-child { grid-column: 1 / -1; }
  }
  @media (max-width: 320px) {
    .sda-stats-grid { grid-template-columns: 1fr; }
    .sda-stats-grid > :last-child { grid-column: auto; }
  }
  .sda-stat-card {
    background: #ffffff; border: 1px solid #BBDEFB; border-radius: 14px;
    padding: 14px 16px; display: flex; align-items: center; gap: 12px;
    box-shadow: 0 2px 8px rgba(13, 71, 161, 0.06);
  }
  .sda-stat-icon {
    width: 42px; height: 42px; border-radius: 12px;
    display: flex; align-items: center; justify-content: center; flex-shrink: 0;
  }
  .sda-stat-val  { font-size: 22px; font-weight: 700; color: #0D2436; line-height: 1; }
  .sda-stat-label{ font-size: 11px; color: #4A6D8C; margin-top: 3px; }

  /* ── Card shell ── */
  .sda-card {
    background: #ffffff; border-radius: 16px; border: 1px solid #BBDEFB;
    margin-bottom: 20px; overflow: hidden; box-shadow: 0 2px 8px rgba(13, 71, 161, 0.06);
  }
  .sda-card-header {
    padding: 14px 18px; border-bottom: 1px solid #E3F2FD;
    font-weight: 700; font-size: 13px; color: #0D47A1;
    letter-spacing: 0.5px; display: flex; align-items: center; gap: 6px;
  }
  .sda-card-header.gradient { background: linear-gradient(135deg, #E3F2FD, #fff); }
  .sda-card-body { padding: 18px; }

  /* ── Staff profile row ── */
  .sda-profile-row {
    display: flex; align-items: center; gap: 14px;
    margin-bottom: 18px; flex-wrap: wrap;
  }
  .sda-avatar {
    width: 66px; height: 66px; border-radius: 18px;
    display: flex; align-items: center; justify-content: center;
    font-weight: 700; font-size: 26px; flex-shrink: 0;
  }
  .sda-staff-name { font-weight: 700; font-size: 17px; color: #0D2436; }
  .sda-staff-sub  { font-size: 12px; color: #4A6D8C; margin-top: 2px; }
  .sda-staff-role { font-size: 12px; color: #4A6D8C; margin-top: 4px; }

  /* ── Action buttons row ── */
  .sda-action-row {
    display: flex; gap: 10px; flex-wrap: wrap; margin-bottom: 8px;
  }
  .sda-action-btn {
    padding: 10px 20px; border-radius: 40px; font-size: 13px;
    font-weight: 600; cursor: pointer; font-family: 'Poppins', sans-serif;
    display: inline-flex; align-items: center; gap: 7px; border: 1px solid transparent;
    white-space: nowrap; transition: all 0.2s;
  }
  @media (max-width: 400px) {
    .sda-action-btn { width: 100%; justify-content: center; }
  }

  /* ── Present record box ── */
  .sda-present-box {
    background: #E3F2FD; border-radius: 12px; padding: 13px 16px;
    border: 1px solid #BBDEFB;
    display: flex; align-items: center; justify-content: space-between;
    flex-wrap: wrap; gap: 10px;
  }

  /* ── History items ── */
  .sda-history-item {
    margin: 0 14px 10px; border: 1px solid #E3F2FD; border-radius: 12px; overflow: hidden;
  }
  .sda-history-top {
    background: #E3F2FD; padding: 9px 14px;
    display: flex; align-items: center; justify-content: space-between;
  }
  .sda-history-bot {
    padding: 11px 14px; background: #ffffff;
    display: flex; justify-content: space-between; align-items: center;
    flex-wrap: wrap; gap: 8px;
  }

  /* ── Holidays grid ── */
  .sda-holiday-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(190px, 1fr));
    gap: 10px;
  }
  @media (max-width: 460px) {
    .sda-holiday-grid { grid-template-columns: 1fr 1fr; }
  }
  @media (max-width: 300px) {
    .sda-holiday-grid { grid-template-columns: 1fr; }
  }
  .sda-holiday-dot {
    width: 8px; height: 8px; border-radius: 50%; background: #0D47A1; flex-shrink: 0;
  }

  /* ── Modal overlay ── */
  .sda-modal-wrap {
    position: fixed; inset: 0; background: rgba(13, 36, 54, 0.6);
    display: flex; align-items: center; justify-content: center;
    z-index: 1000; padding: 16px; overflow-y: auto;
  }
  .sda-modal {
    background: #ffffff; border-radius: 16px; width: 100%; max-width: 440px;
    box-shadow: 0 24px 64px rgba(0,0,0,0.2); overflow: hidden;
  }
  .sda-modal-header {
    background: linear-gradient(135deg, #0D47A1, #006994);
    padding: 14px 18px; display: flex; align-items: center; justify-content: space-between;
  }
  .sda-modal-close {
    background: rgba(255,255,255,0.15); border: none; color: #fff;
    width: 28px; height: 28px; border-radius: 50%; cursor: pointer;
    font-size: 15px; display: flex; align-items: center; justify-content: center;
    transition: all 0.2s;
  }
  .sda-modal-close:hover { background: rgba(255,255,255,0.3); }
  .sda-modal-body { padding: 18px; }

  /* Leave requests modal */
  .sda-modal-scroll { max-height: 72vh; overflow-y: auto; }

  /* Textarea */
  .sda-textarea {
    width: 100%; padding: 9px 12px; border-radius: 8px;
    font-size: 13px; font-family: 'Poppins', sans-serif;
    border: 1px solid #BBDEFB; outline: none; resize: none;
    height: 80px; box-sizing: border-box; background: #fcfcfc;
  }
  .sda-textarea:focus { border-color: #0D47A1; background: #ffffff; }

  .sda-modal-btns { display: flex; gap: 10px; margin-top: 14px; flex-wrap: wrap; }
  .sda-modal-btns button { flex: 1; min-width: 120px; }
`;

/* ── Sub-components ── */

function LiveClock() {
  const [time, setTime] = useState(new Date());
  useEffect(() => {
    const t = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(t);
  }, []);
  const hh = String(time.getHours()).padStart(2, "0");
  const mm = String(time.getMinutes()).padStart(2, "0");
  const ss = String(time.getSeconds()).padStart(2, "0");
  const dateStr = time.toLocaleDateString("en-IN", {
    weekday: "short",
    day: "2-digit",
    month: "short"
  });
  return <div className="sda-clock">
      <div className="sda-clock-time">{hh}:{mm}:{ss}</div>
      <div className="sda-clock-date">{dateStr}</div>
    </div>;
}
function StatusBadge({
  status
}) {
  // Updated colors to match Blue Theme
  const cfg = {
    present: {
      bg: "#E3F2FD",
      color: "#0D47A1",
      icon: "fa-check-circle",
      label: "Present"
    },
    late: {
      bg: "#FFF3E0",
      color: "#E65100",
      icon: "fa-clock",
      label: "Late"
    },
    leave: {
      bg: "#FFEBEE",
      color: "#C62828",
      icon: "fa-calendar-times",
      label: "Leave"
    }
  }[status] || {
    bg: "#f1f5f9",
    color: "#475569",
    icon: "fa-question",
    label: status
  };
  return <span style={{
    background: cfg.bg,
    color: cfg.color,
    padding: "3px 10px",
    borderRadius: 20,
    fontSize: 11,
    fontWeight: 600,
    display: "inline-flex",
    alignItems: "center",
    gap: 4
  }}>
      <i className={`fas ${cfg.icon}`}></i> {cfg.label}
    </span>;
}
function getLeaveStatusBadge(status) {
  if (status === "pending") return {
    bg: "#FFF3E0",
    color: "#E65100",
    icon: "fa-clock",
    label: "Pending Approval"
  };
  if (status === "approved") return {
    bg: "#E3F2FD",
    color: "#0D47A1",
    icon: "fa-check-circle",
    label: "Approved"
  };
  return {
    bg: "#FFEBEE",
    color: "#C62828",
    icon: "fa-times-circle",
    label: "Rejected"
  };
}

/* ── Main export ── */
export default function StaffDailyAttendance() {
  const navigate = useNavigate();
  const [staff, setStaff] = useState(null);
  const [loading, setLoading] = useState(true);
  const [todayRecord, setTodayRecord] = useState(null);
  const [historyData, setHistoryData] = useState([]);
  const [saving, setSaving] = useState(false);
  const [toast, setToast] = useState(null);
  const [leaveModal, setLeaveModal] = useState(false);
  const [leaveNote, setLeaveNote] = useState("");
  const [submittingLeave, setSubmittingLeave] = useState(false);
  const [leaveRequests, setLeaveRequests] = useState([]);
  const [showLeaveRequests, setShowLeaveRequests] = useState(false);
  const todayDate = new Date();
  const todayISO = todayDate.toISOString().split("T")[0];

  /* ── Attendance history month filter ── */
  const [histYear, setHistYear] = useState(todayDate.getFullYear());
  const [histMonth, setHistMonth] = useState(todayDate.getMonth()); // 0-indexed

  const monthLabel = new Date(histYear, histMonth, 1).toLocaleDateString("en-IN", {
    month: "long",
    year: "numeric"
  });
  const isCurrentMonth = histYear === todayDate.getFullYear() && histMonth === todayDate.getMonth();
  const monthInputValue = `${histYear}-${String(histMonth + 1).padStart(2, "0")}`;
  const handleHistMonthChange = e => {
    const val = e.target.value; // "YYYY-MM"
    if (!val) return;
    const [y, m] = val.split("-").map(Number);
    setHistYear(y);
    setHistMonth(m - 1);
  };
  const getLoggedInStaffId = () => localStorage.getItem("staffId") || localStorage.getItem("userId");

  /* ── Data fetching ── */
  useEffect(() => {
    const fetchStaff = async () => {
      const staffId = getLoggedInStaffId();
      if (!staffId) {
        setLoading(false);
        return;
      }
      try {
        let r = await fetch(`https://schoolcrm-fzcv.onrender.com/api/staff/${staffId}`);
        if (!r.ok) {
          const username = localStorage.getItem("userId");
          if (username) r = await fetch(`https://schoolcrm-fzcv.onrender.com/api/staff/username/${username}`);
        }
        if (r.ok) setStaff(await r.json());
      } catch (err) {
        console.error("Error fetching staff:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchStaff();
  }, []);
  useEffect(() => {
    if (!staff) return;
    const fetchToday = async () => {
      try {
        const r = await fetch(`https://schoolcrm-fzcv.onrender.com/api/staff-attendance/today?date=${todayISO}&staffId=${staff._id}`);
        if (r.ok) {
          const data = await r.json();
          setTodayRecord(Array.isArray(data) && data.length > 0 ? data[0] : null);
        }
      } catch (err) {
        console.error("Error fetching today attendance:", err);
      }
    };
    fetchToday();
  }, [todayISO, staff]);
  useEffect(() => {
    if (!staff) return;
    const fetchHistory = async () => {
      try {
        const month = String(histMonth + 1).padStart(2, "0");
        const r = await fetch(`https://schoolcrm-fzcv.onrender.com/api/staff-attendance/month?year=${histYear}&month=${month}&staffId=${staff._id}`);
        if (r.ok) setHistoryData(await r.json());else setHistoryData([]);
      } catch (err) {
        console.error("Error fetching history:", err);
        setHistoryData([]);
      }
    };
    fetchHistory();
  }, [staff, histYear, histMonth]);
  useEffect(() => {
    if (!staff) return;
    const fetchLeave = async () => {
      try {
        const r = await fetch(`https://schoolcrm-fzcv.onrender.com/api/leave-requests/staff/${staff._id}`);
        if (r.ok) setLeaveRequests(await r.json());
      } catch (err) {
        console.error("Error fetching leave requests:", err);
      }
    };
    fetchLeave();
  }, [staff, todayRecord]);

  /* ── Derived ── */
  const daysPresent = historyData.filter(r => r.status === "present" || r.status === "late").length;
  const lateDays = historyData.filter(r => r.status === "late").length;
  const leavesTaken = historyData.filter(r => r.status === "leave").length;
  const pendingRequests = leaveRequests.filter(r => r.status === "pending").length;

  /* ── Helpers ── */
  const showToast = (msg, type = "success") => {
    setToast({
      msg,
      type
    });
    setTimeout(() => setToast(null), 3000);
  };
  const refreshHistory = async () => {
    const month = String(histMonth + 1).padStart(2, "0");
    const r = await fetch(`https://schoolcrm-fzcv.onrender.com/api/staff-attendance/month?year=${histYear}&month=${month}&staffId=${staff._id}`);
    if (r.ok) setHistoryData(await r.json());
  };

  /* ── Actions ── */
  const markAttendance = async status => {
    if (!staff) return;
    setSaving(true);
    const now = new Date();
    const timeStr = now.toLocaleTimeString("en-IN", {
      hour: "2-digit",
      minute: "2-digit"
    });
    try {
      const r = await fetch("https://schoolcrm-fzcv.onrender.com/api/staff-attendance", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          staffId: staff._id,
          date: todayISO,
          status,
          time: timeStr
        })
      });
      if (r.ok) {
        setTodayRecord(await r.json());
        showToast(status === "late" ? "Late arrival marked!" : "Attendance marked as Present!");
        await refreshHistory();
      } else {
        const error = await r.json();
        showToast(error.error || "Failed to save attendance", "error");
      }
    } catch (err) {
      console.error("Error marking attendance:", err);
      showToast("Server error. Is backend running?", "error");
    }
    setSaving(false);
  };

  // Present window: up to and including 9:15 AM is "Present".
  // Even 1 minute past 9:15 AM is auto marked as "Late" — using the
  // real current date/time at the moment the button is pressed, so
  // it's never fetched/stale.
  const PRESENT_GRACE_HOUR = 9;
  const PRESENT_GRACE_MIN = 15;
  const handleMarkPresent = () => {
    const now = new Date();
    const graceDeadline = new Date();
    graceDeadline.setHours(PRESENT_GRACE_HOUR, PRESENT_GRACE_MIN, 0, 0);
    const status = now.getTime() <= graceDeadline.getTime() ? "present" : "late";
    markAttendance(status);
  };
  const handleApplyLeave = async () => {
    if (!staff) return;
    setSubmittingLeave(true);
    try {
      const r = await fetch("https://schoolcrm-fzcv.onrender.com/api/leave-requests", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          staffId: staff._id,
          employeeName: staff.name,
          employeeType: 'Staff',
          employeeDept: staff.dept,
          date: todayISO,
          reason: leaveNote,
          status: "pending"
        })
      });
      if (!r.ok) throw new Error("Failed to send leave request to admin");
      showToast("Leave request sent to admin for approval!");
      setLeaveModal(false);
      setLeaveNote("");
      const req = await fetch(`https://schoolcrm-fzcv.onrender.com/api/leave-requests/staff/${staff._id}`);
      if (req.ok) setLeaveRequests(await req.json());
    } catch (err) {
      console.error("Error applying leave:", err);
      showToast("Failed to send leave request. Please try again.", "error");
    }
    setSubmittingLeave(false);
  };

  /* ── Loading / no-staff states ── */
  if (loading) return <div style={{
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    background: "#E3F2FD"
  }}>
      <div style={{
      textAlign: "center"
    }}>
        <i className="fas fa-spinner fa-pulse" style={{
        fontSize: 32,
        color: "#0D47A1",
        marginBottom: 12
      }}></i>
        <div style={{
        color: "#4A6D8C",
        fontFamily: "'Poppins',sans-serif"
      }}>Loading your details...</div>
      </div>
    </div>;
  if (!staff) return <div style={{
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    background: "#E3F2FD",
    flexDirection: "column"
  }}>
      <div style={{
      textAlign: "center"
    }}>
        <i className="fas fa-user-slash" style={{
        fontSize: 48,
        color: "#4A6D8C",
        marginBottom: 16
      }}></i>
        <div style={{
        fontSize: 16,
        fontWeight: 600,
        color: "#0D2436",
        marginBottom: 8
      }}>Staff Not Found</div>
        <div style={{
        fontSize: 13,
        color: "#4A6D8C",
        marginBottom: 20
      }}>Could not find your staff profile.</div>
        <button onClick={() => navigate("/login")} style={{
        background: "#0D47A1",
        color: "#fff",
        border: "none",
        padding: "10px 24px",
        borderRadius: 8,
        cursor: "pointer",
        fontFamily: "'Poppins',sans-serif",
        fontWeight: 600
      }}>
          Go to Login
        </button>
      </div>
    </div>;

  /* ── Derived colours ── */
  const av = AV_COLORS[staff.dept] || {
    bg: "#E3F2FD",
    color: "#0D47A1"
  };
  const deptColor = DEPT_COLORS[staff.dept] || "#0D47A1";
  const subjects = (staff.subjects || []).join(", ") || staff.role || "";
  const initials = staff.initials || staff.name?.slice(0, 2).toUpperCase();

  /* ══════════════════════════════════════════════════════════════════════════ */
  return <div className="sda-page">
      {/* Inject responsive CSS once */}
      <style>{RESPONSIVE_CSS}</style>

      {/* ── Header ── */}
      <header className="sda-header">
        <div className="sda-header-left">
          <button className="sda-back-btn" onClick={() => navigate(-1)} aria-label="Go back">
            <i className="fas fa-arrow-left"></i>
          </button>
          <div className="sda-header-icon">
            <i className="fas fa-calendar-check" style={{
            color: "#fff",
            fontSize: 17
          }}></i>
          </div>
          <div>
            <div className="sda-header-title">Daily Attendance</div>
            <div className="sda-header-sub">Mark your attendance for today</div>
          </div>
        </div>
        <LiveClock />
      </header>

      {/* ── Toast ── */}
      {toast && <div className="sda-toast" style={{
      background: toast.type === "error" ? "#FFEBEE" : "#E3F2FD",
      border: `1px solid ${toast.type === "error" ? "#FFCDD2" : "#BBDEFB"}`,
      color: toast.type === "error" ? "#C62828" : "#0D47A1"
    }}>
          <i className={`fas ${toast.type === "error" ? "fa-exclamation-circle" : "fa-check-circle"}`}></i>
          {toast.msg}
        </div>}

      {/* ── Main ── */}
      <main className="sda-container">

        {/* Pending banner */}
        {pendingRequests > 0 && <div className="sda-pending-banner">
            <div className="sda-pending-left">
              <i className="fas fa-clock" style={{
            color: "#E65100",
            fontSize: 18
          }}></i>
              <div>
                <div style={{
              fontWeight: 600,
              fontSize: 13,
              color: "#E65100"
            }}>
                  {pendingRequests} Leave Request{pendingRequests > 1 ? "s" : ""} Pending
                </div>
                <div style={{
              fontSize: 11,
              color: "#F57C00"
            }}>Waiting for admin approval</div>
              </div>
            </div>
            <button onClick={() => setShowLeaveRequests(true)} style={{
          background: "#0D47A1",
          color: "#fff",
          border: "none",
          padding: "6px 14px",
          borderRadius: 8,
          fontSize: 12,
          fontWeight: 600,
          cursor: "pointer",
          fontFamily: "'Poppins',sans-serif"
        }}>
              View Requests <ArrowRight className="inline w-[1em] h-[1em] align-[-0.125em]" />
            </button>
          </div>}

        {/* ── Stats grid ── */}
        <div className="sda-stats-grid">
          {[{
          val: daysPresent,
          label: isCurrentMonth ? "Present This Month" : `Present in ${monthLabel}`,
          color: "#0D47A1",
          bg: "#E3F2FD",
          icon: "fa-user-check"
        }, {
          val: lateDays,
          label: "Late Arrivals",
          color: "#E65100",
          bg: "#FFF3E0",
          icon: "fa-clock"
        }, {
          val: leavesTaken,
          label: "Leaves Taken",
          color: "#C62828",
          bg: "#FFEBEE",
          icon: "fa-calendar-times"
        }].map(({
          val,
          label,
          color,
          bg,
          icon
        }) => <div key={label} className="sda-stat-card">
              <div className="sda-stat-icon" style={{
            background: bg
          }}>
                <i className={`fas ${icon}`} style={{
              color,
              fontSize: 17
            }}></i>
              </div>
              <div>
                <div className="sda-stat-val">{val}</div>
                <div className="sda-stat-label">{label}</div>
              </div>
            </div>)}
        </div>

        {/* ── Two-column layout: Today's Attendance (left) + History (right) ── */}
        <div className="sda-layout">

          {/* ── Left column ── */}
          <div className="sda-col">
            {/* ── Today's Attendance card ── */}
            <div className="sda-card">
              <div className="sda-card-header gradient">
                <i className="fas fa-calendar-day" style={{
                color: "#0D47A1"
              }}></i>
                TODAY'S ATTENDANCE
              </div>
              <div className="sda-card-body">
                {/* Profile row */}
                <div className="sda-profile-row">
                  <div className="sda-avatar" style={{
                  background: av.bg,
                  color: av.color
                }}>{initials}</div>
                  <div style={{
                  flex: 1,
                  minWidth: 0
                }}>
                    <div className="sda-staff-name">{staff.name}</div>
                    <div className="sda-staff-sub">{staff.username || "—"} · {staff.dept}</div>
                    <div className="sda-staff-role">{subjects || staff.role}</div>
                    <span style={{
                    background: `${deptColor}18`,
                    color: deptColor,
                    fontSize: 11,
                    fontWeight: 600,
                    padding: "2px 10px",
                    borderRadius: 20,
                    marginTop: 6,
                    display: "inline-block"
                  }}>
                      {staff.dept}
                    </span>
                  </div>
                </div>

                {/* Already marked */}
                {todayRecord ? <div className="sda-present-box">
                    <div>
                      <StatusBadge status={todayRecord.status} />
                      <div style={{
                    fontSize: 11,
                    color: "#4A6D8C",
                    marginTop: 6
                  }}>
                        Marked at {todayRecord.time}
                        {todayRecord.note ? ` · Note: ${todayRecord.note}` : ""}
                      </div>
                    </div>
                    {todayRecord.status === "leave" && <div style={{
                  fontSize: 11,
                  color: "#4A6D8C",
                  fontStyle: "italic"
                }}>Leave applied</div>}
                  </div> : (/* Action buttons */
              <div>
                    <div className="sda-action-row">
                      <button className="sda-action-btn" onClick={handleMarkPresent} disabled={saving} style={{
                    background: "#E3F2FD",
                    color: "#0D47A1",
                    border: "1px solid #BBDEFB",
                    cursor: saving ? "not-allowed" : "pointer"
                  }}>
                        {saving ? <i className="fas fa-spinner fa-pulse"></i> : <i className="fas fa-check-circle"></i>}
                        Present
                      </button>

                      <button className="sda-action-btn" onClick={() => setLeaveModal(true)} style={{
                    background: "#0D47A1",
                    color: "#fff",
                    border: "none",
                    cursor: "pointer"
                  }}>
                        <i className="fas fa-paper-plane"></i> Apply Leave &amp; Send to Admin
                      </button>
                    </div>
                    <div style={{
                  fontSize: 11,
                  color: "#4A6D8C",
                  marginTop: 8,
                  display: "flex",
                  alignItems: "center",
                  gap: 4
                }}>
                      <i className="fas fa-info-circle"></i> Marked Present up to 9:15 AM — even 1 minute after, it's auto-marked Late
                    </div>
                  </div>)}
              </div>
            </div>

            {/* ── Government Holidays card ── */}
            <div className="sda-card">
              <div className="sda-card-header">
                <i className="fas fa-flag" style={{
                color: "#0D47A1"
              }}></i>
                GOVERNMENT HOLIDAYS 2026
              </div>
              <div className="sda-card-body">
                <div className="sda-holiday-grid">
                  {GOVT_HOLIDAYS_2026.map(h => <div key={h.date + h.name} style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 8
                }}>
                      <div className="sda-holiday-dot"></div>
                      <div>
                        <div style={{
                      fontSize: 12,
                      fontWeight: 500,
                      color: "#0D2436"
                    }}>{h.name}</div>
                        <div style={{
                      fontSize: 10,
                      color: "#4A6D8C"
                    }}>{h.date}</div>
                      </div>
                    </div>)}
                </div>
              </div>
            </div>
          </div>

          {/* ── Right column ── */}
          <div className="sda-col">
            {/* ── Attendance History card ── */}
            <div className="sda-card">
              <div className="sda-history-header">
                <div style={{
                display: "flex",
                alignItems: "center",
                gap: 6,
                fontWeight: 700,
                fontSize: 13,
                color: "#0D47A1",
                letterSpacing: 0.5
              }}>
                  <i className="fas fa-history" style={{
                  color: "#0D47A1"
                }}></i>
                  ATTENDANCE HISTORY
                </div>
                <div style={{
                display: "flex",
                alignItems: "center",
                gap: 8
              }}>
                  <span style={{
                  fontSize: 11,
                  color: "#4A6D8C"
                }}>{monthLabel}</span>
                  <input type="month" className="sda-month-input" value={monthInputValue} max={`${todayDate.getFullYear()}-${String(todayDate.getMonth() + 1).padStart(2, "0")}`} onChange={handleHistMonthChange} aria-label="Select month to view attendance history" />
                </div>
              </div>

              <div className="sda-history-scroll">
                {historyData.length === 0 ? <div style={{
                padding: "44px 20px",
                textAlign: "center",
                color: "#4A6D8C",
                fontSize: 13
              }}>
                    <i className="fas fa-calendar-week" style={{
                  fontSize: 30,
                  marginBottom: 10,
                  display: "block"
                }}></i>
                    No history yet for {monthLabel}
                  </div> : <div style={{
                padding: "10px 0"
              }}>
                    {historyData.map((rec, idx) => {
                  const d = new Date(rec.date);
                  const dayLabel = d.toLocaleDateString("en-IN", {
                    weekday: "short",
                    day: "2-digit",
                    month: "short"
                  });
                  return <div key={idx} className="sda-history-item">
                          <div className="sda-history-top">
                            <div style={{
                        fontWeight: 600,
                        fontSize: 13,
                        color: "#0D2436"
                      }}>{dayLabel}</div>
                            <StatusBadge status={rec.status} />
                          </div>
                          <div className="sda-history-bot">
                            <div>
                              <div style={{
                          fontSize: 12,
                          color: "#4A6D8C"
                        }}>
                                <i className="far fa-clock" style={{
                            marginRight: 5
                          }}></i>{rec.time || "—"}
                              </div>
                              {rec.note && <div style={{
                          fontSize: 11,
                          color: "#4A6D8C",
                          marginTop: 4
                        }}><FileEdit className="inline w-[1em] h-[1em] align-[-0.125em]" /> {rec.note}</div>}
                            </div>
                            <div style={{
                        fontSize: 11,
                        color: "#4A6D8C"
                      }}>
                              {rec.status === "present" && "Marked Present"}
                              {rec.status === "late" && "⏰ Late Arrival"}
                              {rec.status === "leave" && "On Leave"}
                            </div>
                          </div>
                        </div>;
                })}
                  </div>}
              </div>
            </div>
          </div>

        </div>

      </main>{/* /sda-container */}

      {/* ══ Leave Apply Modal ══ */}
      {leaveModal && <div className="sda-modal-wrap">
          <div className="sda-modal">
            <div className="sda-modal-header">
              <div style={{
            fontWeight: 700,
            fontSize: 14,
            color: "#fff",
            display: "flex",
            alignItems: "center",
            gap: 6
          }}>
                <i className="fas fa-paper-plane" style={{
              color: "#f87171"
            }}></i> Apply Leave &amp; Send to Admin
              </div>
              <button className="sda-modal-close" onClick={() => setLeaveModal(false)} aria-label="Close">
                <i className="fas fa-times"></i>
              </button>
            </div>
            <div className="sda-modal-body">
              {/* Mini profile */}
              <div style={{
            display: "flex",
            alignItems: "center",
            gap: 10,
            marginBottom: 14,
            background: "#E3F2FD",
            borderRadius: 10,
            padding: "10px 12px"
          }}>
                <div style={{
              width: 38,
              height: 38,
              borderRadius: 10,
              background: av.bg,
              color: av.color,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontWeight: 700,
              fontSize: 13,
              flexShrink: 0
            }}>
                  {initials}
                </div>
                <div>
                  <div style={{
                fontWeight: 600,
                fontSize: 13,
                color: "#0D2436"
              }}>{staff.name}</div>
                  <div style={{
                fontSize: 11,
                color: "#4A6D8C"
              }}>{staff.dept} · {staff.role}</div>
                </div>
              </div>

              <label style={{
            fontSize: 12,
            fontWeight: 500,
            color: "#4A6D8C",
            marginBottom: 6,
            display: "block"
          }}>Reason for Leave</label>
              <textarea className="sda-textarea" value={leaveNote} onChange={e => setLeaveNote(e.target.value)} placeholder="Please provide reason for leave..." />

              <div className="sda-modal-btns">
                <button onClick={handleApplyLeave} disabled={submittingLeave} style={{
              background: submittingLeave ? "#90CAF9" : "#0D47A1",
              color: "#fff",
              border: "none",
              padding: "10px 0",
              borderRadius: 8,
              fontSize: 13,
              fontWeight: 600,
              cursor: submittingLeave ? "not-allowed" : "pointer",
              fontFamily: "'Poppins',sans-serif",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 6
            }}>
                  {submittingLeave ? <><i className="fas fa-spinner fa-pulse"></i> Sending...</> : <><i className="fas fa-paper-plane"></i> Send to Admin</>}
                </button>
                <button onClick={() => setLeaveModal(false)} style={{
              background: "#E3F2FD",
              color: "#0D47A1",
              border: "1px solid #BBDEFB",
              padding: "10px 0",
              borderRadius: 8,
              fontSize: 13,
              fontWeight: 600,
              cursor: "pointer",
              fontFamily: "'Poppins',sans-serif",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 6
            }}>
                  <i className="fas fa-times"></i> Cancel
                </button>
              </div>
            </div>
          </div>
        </div>}

      {/* ══ Leave Requests Modal ══ */}
      {showLeaveRequests && <div className="sda-modal-wrap">
          <div className="sda-modal">
            <div className="sda-modal-header" style={{
          position: "sticky",
          top: 0
        }}>
              <div style={{
            fontWeight: 700,
            fontSize: 14,
            color: "#fff",
            display: "flex",
            alignItems: "center",
            gap: 6
          }}>
                <i className="fas fa-list"></i> My Leave Requests
              </div>
              <button className="sda-modal-close" onClick={() => setShowLeaveRequests(false)} aria-label="Close">
                <i className="fas fa-times"></i>
              </button>
            </div>
            <div className="sda-modal-scroll">
              <div style={{
            padding: "14px"
          }}>
                {leaveRequests.length === 0 ? <div style={{
              textAlign: "center",
              padding: "36px",
              color: "#4A6D8C"
            }}>
                    <i className="fas fa-inbox" style={{
                fontSize: 36,
                marginBottom: 10
              }}></i>
                    <div>No leave requests found</div>
                  </div> : leaveRequests.map(req => {
              const s = getLeaveStatusBadge(req.status);
              return <div key={req._id} style={{
                border: "1px solid #E3F2FD",
                borderRadius: 12,
                padding: "12px 14px",
                marginBottom: 10
              }}>
                        <div style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: 8,
                  flexWrap: "wrap",
                  gap: 6
                }}>
                          <div style={{
                    fontWeight: 600,
                    fontSize: 13,
                    color: "#0D2436"
                  }}>
                            {new Date(req.date).toLocaleDateString("en-IN", {
                      weekday: "short",
                      day: "2-digit",
                      month: "short",
                      year: "numeric"
                    })}
                          </div>
                          <span style={{
                    background: s.bg,
                    color: s.color,
                    padding: "2px 8px",
                    borderRadius: 12,
                    fontSize: 10,
                    fontWeight: 600
                  }}>
                            <i className={`fas ${s.icon}`} style={{
                      marginRight: 3,
                      fontSize: 9
                    }}></i>{s.label}
                          </span>
                        </div>
                        {req.reason && <div style={{
                  fontSize: 12,
                  color: "#4A6D8C",
                  marginBottom: 8
                }}><FileEdit className="inline w-[1em] h-[1em] align-[-0.125em]" /> {req.reason}</div>}
                        {req.adminRemark && req.status !== "pending" && <div style={{
                  fontSize: 11,
                  color: "#4A6D8C",
                  marginTop: 6,
                  paddingTop: 6,
                  borderTop: "1px solid #E3F2FD"
                }}>
                            <i className="fas fa-comment"></i> {req.adminRemark}
                          </div>}
                      </div>;
            })}
              </div>
            </div>
          </div>
        </div>}
    </div>;
}